import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-tutorial-videos',
  templateUrl: './tutorial-videos.component.html',
  standalone: false
})
export class TutorialVideosComponent implements OnInit {

  tutorialCategories = [
    {
      name: 'Rövid bemutatók',
      icon: 'lucideSparkle',
      videos: [
        {
          videoUrl: 'https://www.youtube.com/watch?v=KeZfp-OOKaY',
        },
        {
          videoUrl: 'https://www.youtube.com/watch?v=y3Wu9Jv_O_Q',
        },
      ]
    },
    {
      name: "Részletes videók",
      icon: "lucideVideo",
      videos: [
        {
          videoUrl: 'https://www.youtube.com/watch?v=4g1hIlUsflE',
        },
        {
          videoUrl:'https://www.youtube.com/watch?v=2aa1UZEUz50'
        }
      ]
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
